import "./TableOtherAccessContainer.scss"

export default function TableOtherAccessContainer({children}) {
    return (
        <div className={"accessItemContainer"}>
            {children}
        </div>)
}
